import { render, staticRenderFns } from "./DiarysDetail.vue?vue&type=template&id=ff4cd0f4&scoped=true&"
import script from "./DiarysDetail.vue?vue&type=script&lang=js&"
export * from "./DiarysDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiarysDetail.vue?vue&type=style&index=0&id=ff4cd0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4cd0f4",
  null
  
)

export default component.exports